// Instrumentos de medición.
import { definePart, PITCH } from './registry.js';

export const LA = { w: 26, d: 44, h: 10.5 };

definePart({
  type: 'logic-analyzer',
  name: 'Analizador lógico',
  category: 'instrumentos',
  description: 'Registra hasta 8 señales digitales y las dibuja en la pestaña «Analizador» del panel inferior, con frecuencia y ciclo de trabajo.',
  keywords: 'osciloscopio señales logic analyzer saleae pwm protocolo',
  pins: [
    ...Array.from({ length: 8 }, (_, i) => ({
      name: 'CH' + i,
      label: `Canal ${i}`,
      kind: 'signal',
      x: (i - 4) * PITCH,
      y: LA.h + 6.2,
      z: LA.d / 2 + 1.6,
    })),
    { name: 'GND', label: 'GND (referencia)', kind: 'gnd', x: 4 * PITCH, y: LA.h + 6.2, z: LA.d / 2 + 1.6 },
  ],
  footprint: { w: LA.w + 2, d: LA.d + 6, h: 18, z: 1 },
  help: 'Une GND del analizador con GND del circuito y cada canal a la señal que quieras ver. Las señales aparecen en la pestaña «Analizador».',
});
